<template>
  <router-link to="/"></router-link>
  <router-view />
</template>

<script setup>
import MainPage from "./views/tabs/MainPage.vue";
</script>

<style>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  background-color: #f8f9fa;
  color: #333;
  box-sizing: border-box;
}
</style>
